import { render, staticRenderFns } from "./WelcomeToTheMoonScoresByCampaign.vue?vue&type=template&id=3aced590"
import script from "./WelcomeToTheMoonScoresByCampaign.vue?vue&type=script&lang=ts"
export * from "./WelcomeToTheMoonScoresByCampaign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports